var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 107,
    viewBox: "0 0 150 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08472 8.70911V97.7713L53.9431 48.0037L4.08472 8.70911Z",
    fill: "#99844E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3041 62.7817C76.6277 63.3153 75.8139 63.5814 75 63.5814C74.1861 63.5814 73.3722 63.3153 72.6958 62.7817L59.8541 52.6613L9.37219 103.049H140.626L90.1458 52.6613L77.3041 62.7817Z",
    fill: "#99844E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.915 97.7713V8.70911L96.0569 48.0037L145.915 97.7713Z",
    fill: "#99844E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.878 3.95117H10.1222L75 55.0813L139.878 3.95117Z",
    fill: "#99844E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcons);
export default __webpack_public_path__ + "static/media/email_icons.86bd297e2040ddc2eb027211a3d28a3b.svg";
export { ForwardRef as ReactComponent };